<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Vendor ID</strong>
          </b-col>
          <b-col>
            {{ inbound_shipment.vendor_id }}
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Shipment Type</strong>
          </b-col>
          <b-col>
            {{ inbound_shipment.shipment_type }}
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Shipment#</strong>
          </b-col>
          <b-col>
            {{ inbound_shipment.shipment_no }}
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Received at</strong>
          </b-col>
          <b-col>
            {{ displayDate(inbound_shipment.received_at) }}
          </b-col>
        </b-row>
      </b-card>

      <h4 class="mt-3">
        Products
      </h4>

      <b-card>
        <div class="mb-3">
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="product_search_criteria.status_selected"
                :options="product_status_options"
              />
            </b-col>
            <b-col cols="4" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="SKU / Description"
                v-model="product_search_criteria.keyword"
              ></b-form-input>
            </b-col>
            <b-col class="text-left p-0">
              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="getInbound_Shipment_Products"
              >
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>
            </b-col>
          </b-row>
        </div>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          sticky-header="400px"
          :items="product_items"
          :fields="product_fields"
        >
          <template v-slot:head(chk_box)="data">
            <b-form-checkbox
              size="sm"
              plain
              id="chkbox_all"
              value="all"
              v-model="check_all_products"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(chk_box)="data">
            <b-form-checkbox
              size="sm"
              class="chkbox_row"
              plain
              :id="'chkbox_row_' + data.index"
              v-model="data.item.is_checked"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(item_number)="data">
            {{ data.item.item_number }}
            <!-- <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.item_number"
            ></b-form-input> -->
          </template>

          <template v-slot:cell(item_description)="data">
            <div
              class="text-ellipsis"
              v-b-tooltip.hover.right
              :title="data.item.item_description"
            >
              {{ data.item.item_description }}
            </div>
          </template>

          <!-- <template v-slot:cell(gols_qty)="data">
            <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.gols_qty"
            ></b-form-input>
          </template> -->

          <template v-slot:cell(supplier_lot)="data">
            <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.supplier_lot"
            ></b-form-input>
          </template>

          <template v-slot:cell(expiration_date)="data">
            <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.expiration_date"
            ></b-form-input>
          </template>

          <template v-slot:cell(product_remark)="data">
            <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.product_remark"
            ></b-form-input>
          </template>

          <template v-slot:cell(diff_qty)="data">
            <span v-if="data.item.gols_qty == 0" class="dot_yellow"></span>
            <span
              v-if="data.item.gols_qty != 0 && data.item.diff_qty != 0"
              class="dot_red"
            ></span>
            <span
              v-if="data.item.gols_qty != 0 && data.item.diff_qty == 0"
              class="dot_green"
            ></span>

            <span>{{ data.item.diff_qty }}</span>
          </template>

          <template v-slot:cell(eta)="data">
            {{ displayDate(data.item.eta) }}
          </template>

          <template v-slot:cell(received_at)="data">
            {{ displayDate(data.item.received_at) }}
          </template>

          <template v-slot:cell(action)="data">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="showModal_newExpectedQty(data.item)"
              >Amend Exp. QTY</b-button
            >

            <!-- <b-button
            v-if="$store.state.user_obj.account_type != 'client_user'"
              class="btn-action"
              size="sm"
              variant="info"
              @click="showModal_newGOLSQty(data.item)"
              >Amend Rec. QTY</b-button
            > -->

            <b-button
            v-if="$store.state.user_obj.account_type != 'client_user'"
              class="btn-action"
              size="sm"
              variant="info"
              @click="showModal_newAdjustmentQty(data.item)"
              >Amend Adj. QTY</b-button
            >

            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="addDiffProducts(data.item)"
              :disabled="data.item.diff_qty == 0"
              >Move Diff QTY as Pending</b-button
            >
          </template>
        </b-table>
      </b-card>

      <h4 class="mt-3">Documents</h4>
      <b-card>
        <div class="search_bar mb-3">
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-input
                id="input-small"
                type="text"
                placeholder="Document Name"
                v-model="new_doc_record.name"
              ></b-form-input>
            </b-col>
            <b-col cols="3" class="pl-0 pr-1">
              <b-form-file
                v-model="new_doc_record.upload_file"
                placeholder="Choose a file..."
              ></b-form-file>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" variant="info" @click="onUploadFile"
                >Upload</b-button
              >
            </b-col>
          </b-row>
        </div>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="document_items"
          :fields="document_fields"
        >
          <template v-slot:cell(document_name)="data">
            <a :href="data.item.url" target="_blank">
              {{ data.item.document_name }}
            </a>
          </template>

          <template v-slot:cell(created_at)="data">
            <div v-if="data.item.updated_by != ''">
              {{ data.item.created_at }}
            </div>
          </template>
        </b-table>
      </b-card>

      <b-modal ref="modal_newExpectedQty" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><b-form-input
                class=""
                size="sm"
                type="text"
                placeholder="NEW Expected QTY"
                v-model="updating_item.new_expected_qty"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_newExpectedQty"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="amendProduct(updating_item)"
            >Submit</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_newGOLSQty" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><b-form-input
                class=""
                size="sm"
                type="text"
                placeholder="NEW RECEIVED QTY"
                v-model="updating_item.new_gols_qty"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_newGOLSQty"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="amendReceived(updating_item)"
            >Submit</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_newAdjustmentQty" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><b-form-input
                class=""
                size="sm"
                type="text"
                placeholder="NEW ADJUSTMENT QTY"
                v-model="updating_item.new_adjustment_qty"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_newAdjustmentQty"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="amendAdjustment(updating_item)"
            >Submit</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "carried_by",
    label: "Carried by"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  }
];

import CsIssue_Card from "../components/CsIssue_Card.vue";

export default {
  name: "InboundShipmentDN",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode,
    "cs-issue-card": CsIssue_Card
  },
  data() {
    return {
      shipment_record_obj: {
        products: [],
        shipment_no: ""
      },
      new_doc_record: {},
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Inbound Shipment",
          to: { name: "inbound_shipments" }
        },
        {
          text: "Detail",
          to: {
            name: "inbound_shipment",
            params: {
              inbound_shipment_id: this.$route.params.inbound_shipment_id
            }
          }
        },
        {
          text: "Shipment Record",
          active: true
        }
      ],
      document_items: [],
      document_fields: [
        {
          key: "document_name",
          label: "Document Name"
        },
        {
          key: "created_by",
          label: "Created By"
        },
        {
          key: "created_at",
          label: "Created at"
        }
      ],

      inbound_shipment_dns: [],
      inbound_shipment_dns_fields: [
        {
          key: "shipment_no",
          label: "Shipment#"
        },
        {
          key: "gols_qty",
          label: "Received QTY"
        },
        {
          key: "adjustment_qty",
          label: "Adjustment QTY"
        },
        {
          key: "diff_qty",
          label: "Diff QTY"
        },
        {
          key: "dn_created_at",
          label: "Created at"
        }
      ],

      product_items: [],
      product_fields: [
        // {
        //   key: "chk_box",
        //   label: ""
        // },
        {
          key: "dn_no",
          label: "DN#"
        },
        {
          key: "product_sku",
          label: "Product SKU"
        },
        // {
        //   key: "channel_sku",
        //   label: "Channel SKU"
        // },
        {
          key: "other_sku",
          label: "Other SKU"
        },
        {
          key: "item_description",
          label: "Description",
          class: "td_maxwidth150"
        },
        {
          key: "expected_qty",
          label: "Expected QTY",
          class: "center_align"
        },
        {
          key: "gols_qty",
          label: "Received QTY",
          class: "center_align"
        },
        {
          key: "adjustment_qty",
          label: "Adjustment QTY",
          class: "center_align"
        },
        {
          key: "diff_qty",
          label: "Diff QTY",
          class: "center_align"
        },
        {
          key: "eta",
          label: "ETA",
          class: "center_align"
        },
        {
          key: "received_at",
          label: "Received Date",
          class: "center_align"
        },
        {
          key: "created_at",
          label: "Upload Date",
          class: "center_align"
        },
        // {
        //   key: "diff_qty",
        //   label: "Diff QTY",
        //   class: "center_align"
        // },
        // {
        //   key: "product_remark",
        //   label: "Remark"
        // },
        {
          key: "action",
          label: "Action"
        }
      ],
      shipment_product_fields: [
        {
          key: "product_sku",
          label: "Product SKU"
        },
        {
          key: "channel_sku",
          label: "Channel SKU"
        },
        {
          key: "other_sku",
          label: "Other SKU"
        },
        // {
        //   key: "item_description",
        //   label: "Description"
        // },
        {
          key: "expected_qty",
          label: "Pending QTY",
          class: "center_align"
        },
        {
          key: "gols_qty",
          label: "Received QTY",
          class: "center_align"
        },
        {
          key: "adjustment_qty",
          label: "Adjustment QTY",
          class: "center_align"
        },
        {
          key: "product_remark",
          label: "Remark"
        }
      ],
      loader: false,
      items: [{ id: false }],
      inbound_shipment: { id: false },
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      inventory_type_options: [
        {
          value: "Active",
          text: "Active"
        },
        {
          value: "Damaged",
          text: "Damaged"
        },
        {
          value: "Hold",
          text: "Hold"
        },
        {
          value: "Expired",
          text: "Expired"
        },
        {
          value: "Committed",
          text: "Committed"
        }
      ],
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      document_file: [],
      file_document: false,
      location_options: [],
      check_all_products: false,
      product_search_criteria: {
        status_selected: null,
        keyword: null
      },
      product_status_options: [
        {
          value: null,
          text: "All Items"
        },
        {
          value: "received",
          text: "Received Items"
        },
        {
          value: "cancelled",
          text: "Cancelled Items"
        }
      ]
    };
  },
  async created() {
    await this.getInbound_Shipment();
    await this.getInbound_Shipment_Products();
    await this.getInbound_Shipment_Docs();
    // await this.getInbound_Shipment_DN();
    await this.getWMS_Locations();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_products: function(new_val, old_val) {
      // this.check_all_products = !this.check_all_products;
      console.log("check_all_products");
      if (new_val == "all") {
        // Check all
        for (let i in this.product_items) {
          this.product_items[i].is_checked = true;
        }
      } else {
        for (let i in this.product_items) {
          this.product_items[i].is_checked = false;
        }
      }
      console.log(this.product_items);
    }
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getInbound_Shipment() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.inbound_shipment = response.data.inbound_shipments[0];
      this.items.push(this.inbound_shipment);

      this.loader.hide();
    },

    async getInbound_Shipment_DN() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_dn_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.inbound_shipment_dns = response.data.inbound_shipment_dns;

      this.loader.hide();
    },

    async getInbound_Shipment_Products() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_product_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          shipment_no: this.inbound_shipment.shipment_no,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          search_criteria: this.product_search_criteria
        }
      });
      for (let i in response.data.inbound_shipment_products) {
        if (
          !response.data.inbound_shipment_products[i].qty_groups ||
          response.data.inbound_shipment_products[i].qty_groups.length == 0
        ) {
          response.data.inbound_shipment_products[i].qty_groups = [
            {
              quantity: response.data.inbound_shipment_products[i].qty,
              inventory_type: null,
              location: ""
            }
          ];
        }
      }
      this.product_items = response.data.inbound_shipment_products;

      this.loader.hide();
    },

    async getInbound_Shipment_Docs() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_doc_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.document_items = response.data.inbound_shipment_docs;

      this.loader.hide();
    },

    async updateProductsInfo() {
      console.log(this.product_items);

      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        product_items: this.product_items,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_info.php",
        data: params
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
    },

    async updateProductsStatus(status) {
      let params = {
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        product_items: this.product_items,
        user_id: this.$store.state.user_obj.user_id,
        status: status
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_status.php",
        data: params
      });

      this.getInbound_Shipment_Products();
    },

    async updateInvoiceStatus() {
      let params = {
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        invoice_no: this.inbound_shipment.invoice_no,
        user_id: this.$store.state.user_obj.user_id,
        status: "received"
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_invoice_status.php",
        data: params
      });

      this.getInbound_Shipment();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("doc_file", this.new_doc_record.upload_file);
      formData.append("document_name", this.new_doc_record.name);
      formData.append("shipment_no", this.inbound_shipment.shipment_no);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_upload_document.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }
      this.new_doc_record = {};
      this.getInbound_Shipment_Docs();
    },

    addQtyRow(item, item_index) {
      this.product_items[item_index].qty_groups.push({
        quantity: item.qty,
        inventory_type: "Active",
        location: ""
      });
    },

    addProductRow() {
      this.product_items.push({});
    },

    async getWMS_Locations() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_location_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT
        }
      });

      this.location_options = [
        {
          value: null,
          text: "-"
        }
      ];

      for (let i in response.data.locations) {
        let location_obj = {
          value: response.data.locations[i].location_code,
          text: response.data.locations[i].location_code
        };

        this.location_options.push(location_obj);
      }
    },
    downloadDoc(item) {
      let download_url = item.url;
      window.open(download_url, "_blank");
    },

    showModal_createShipment() {
      this.shipment_record_obj = {
        products: [],
        shipment_no: ""
      };

      // get checked items
      for (let i in this.product_items) {
        if (this.product_items[i].is_checked) {
          this.shipment_record_obj.products.push(
            JSON.parse(JSON.stringify(this.product_items[i]))
          );
        }
      }

      this.$refs.modal_createShipment.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_createShipment() {
      this.$refs.modal_createShipment.hide();
    },

    async createShipment() {
      console.log(this.shipment_record_obj);

      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        shipment_no: this.shipment_record_obj.shipment_no,
        product_items: this.shipment_record_obj.products,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_info.php",
        data: params
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
    },

    async amendProduct(item) {
      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        shipment_no: this.shipment_record_obj.shipment_no,
        new_expected_qty: item.new_expected_qty,
        item: item,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_dn_amend.php",
        data: params
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
      this.hideModal_newExpectedQty();
    },

    async amendReceived(item) {
      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        shipment_no: this.shipment_record_obj.shipment_no,
        new_gols_qty: item.new_gols_qty,
        item: item,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_dn_amend_received.php",
        data: params
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
      this.hideModal_newGOLSQty();
    },

    async amendAdjustment(item) {
      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        shipment_no: this.shipment_record_obj.shipment_no,
        new_adjustment_qty: item.new_adjustment_qty,
        item: item,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_dn_amend_adjustment.php",
        data: params
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
      this.hideModal_newAdjustmentQty();
    },

    async addDiffProducts(item) {
      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        shipment_no: this.shipment_record_obj.shipment_no,
        item: item,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_dn_add_diff.php",
        data: params
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();

      this.$eventHub.$emit("show_modal_message", {
        message_content: "Move Diff Qty to Pending SUCCESS"
      });
    },

    showModal_newExpectedQty(item) {
      this.updating_item = item;
      this.$refs.modal_newExpectedQty.show();
    },

    hideModal_newExpectedQty() {
      this.$refs.modal_newExpectedQty.hide();
    },

    showModal_newGOLSQty(item) {
      this.updating_item = item;
      this.$refs.modal_newGOLSQty.show();
    },

    hideModal_newGOLSQty() {
      this.$refs.modal_newGOLSQty.hide();
    },

    showModal_newAdjustmentQty(item) {
      this.updating_item = item;
      this.$refs.modal_newAdjustmentQty.show();
    },

    hideModal_newAdjustmentQty() {
      this.$refs.modal_newAdjustmentQty.hide();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.file_document {
  display: none;
}

.preview_img-product {
  max-width: 100%;
  max-height: 200px;
}

.container-preview_img {
  padding: 5px;
}

.icon-add_image {
  color: #cacaca;
}
</style>



// WEBPACK FOOTER //
// src/components/InboundShipmentDN.vue